import Card from '@mui/material/Card';
import Container from '@mui/material/Container';
import Link from '@mui/material/Link';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import React from 'react';

import Button from '../global/components/Button/Button';

const StyledBackground = styled('div')(({ theme }) => ({
    backgroundColor: '#f9f9f9',
    display: 'flex',
    justifyContent: 'center',
    padding: '5rem 8rem',

    [theme.breakpoints.down('lg')]: {
        padding: '4rem 6rem'
    },
    [theme.breakpoints.down('md')]: {
        padding: '4rem'
    },
    [theme.breakpoints.down('sm')]: {
        padding: '3rem 1rem'
    }
}));

const StyledContainer = styled(Container)(({ theme }) => ({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexWrap: 'wrap',
    margin: '0',

    [theme.breakpoints.down('sm')]: {
        justifyContent: 'center'
    }
}));

const StyledContent = styled(Container)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    flexBasis: `${(5 / 12) * 100}%`,
    margin: 0,
    marginRight: '6rem',

    [theme.breakpoints.down('md')]: {
        minWidth: theme.spacing(32),
        flexBasis: '100%',
        marginBottom: theme.spacing(6),
        marginRight: '0'
    }
}));

const StyledCard = styled(Card)(() => ({
    display: 'flex',
    justifyContent: 'space-around',
    flexDirection: 'column',
    padding: '2rem',
    boxShadow:
        '0px 20px 25px rgba(0, 0, 0, 0.1), 0px 10px 10px rgba(0, 0, 0, 0.04)'
}));

const StyledImage = styled('img')(({ theme }) => ({
    maxWidth: `${(4 / 12) * 100}%`,
    [theme.breakpoints.down('md')]: {
        maxWidth: `${(7 / 12) * 100}%`,
        minWidth: theme.spacing(32)
    },
    [theme.breakpoints.down('sm')]: {
        maxWidth: `${(10 / 12) * 100}%`,
        minWidth: theme.spacing(32)
    }
}));

export interface JoinProps {
    image?: { file: { url: string } };
    heading: string;
    content: string;
    link: { link: string; content: string; id: string };
}

export default function JoinSection(props: JoinProps) {
    return (
        <>
            <StyledBackground id='join'>
                <StyledContainer disableGutters>
                    <StyledContent disableGutters>
                        <StyledCard>
                            <Typography
                                sx={{
                                    fontWeight: '600',
                                    lineHeight: '1.5',
                                    mb: 3
                                }}
                                variant={'body2'}
                                color='#676767'
                                component='h6'
                            >
                                {`${props.heading}*`}
                            </Typography>
                            <div>
                                <Button
                                    link={props.link.link}
                                    variant='contained'
                                    id={props.link.id}
                                >
                                    {props.link.content}
                                </Button>
                            </div>
                        </StyledCard>
                    </StyledContent>
                    {props.image && <StyledImage src={props.image.file.url} />}
                    <Typography
                        sx={{
                            mt: 5,
                            maxWidth: '60rem',
                            fontSize: '0.875rem'
                        }}
                        variant={'body2'}
                        color='#676767'
                        component='p'
                    >
                        {"*By joining, you agree to Levyl's "}
                        <Link
                            href='/public/terms'
                            color='primary'
                            underline={'none'}
                        >
                            {'Terms of Use'}
                        </Link>
                        {' and '}
                        <Link
                            href='/public/privacy-policy'
                            color='primary'
                            underline={'none'}
                        >
                            {'Privacy Policy'}
                        </Link>
                        {
                            '. By providing your email, you consent to receive marketing communications from Levyl, with the option to unsubscribe at any time. For more details, please visit our Privacy Policy or contact us at support@levyl.app'
                        }
                    </Typography>
                </StyledContainer>
            </StyledBackground>
        </>
    );
}
